import { GD } from "src/GD";
import { hasRole } from "src/permissions";
import { defaultBanFilters, getBanListRequest, parseBanList, readBanResponse, type BanRecord } from "../pages/administration/banData";
import { createBanStatusCache, type BanStatusContext } from "./banStatusCache";

const loadRows = async (scope: BanStatusContext, signal: AbortSignal): Promise<BanRecord[]> => {
	const assertContext = async () => {
		const [profile, project] = await Promise.all([GD.REQ_PROFILE.request(), GD.REQ_CURRENT_PROJECT.request()]);
		if (signal.aborted || profile?.id !== scope.userId || project?.id !== scope.projectId || !hasRole(profile?.projects.find(item => item.id === scope.projectId)?.roles, "admin")) throw new Error("contextChanged");
	};
	const rows: BanRecord[] = [];
	const seen = new Set<string>();
	const pages = new Set<string>();
	for (let page = 0; page < 1000; page++) {
		await assertContext();
		const response = readBanResponse(await GD.REQ_API.request({ ...getBanListRequest(scope.projectId, defaultBanFilters(), page, 100), signal }));
		await assertContext();
		if (response.error) throw new Error(response.error);
		const parsed = parseBanList(response.data);
		if (!parsed) throw new Error("unrecognized");
		const fingerprint = JSON.stringify(parsed.rows);
		if (pages.has(fingerprint)) throw new Error("unrecognized");
		pages.add(fingerprint);
		for (const row of parsed.rows) {
			if (typeof row.entity_type !== "string" || typeof row.entity_value !== "string") throw new Error("unrecognized");
			const key = row.id == null ? JSON.stringify(row) : String(row.id);
			if (seen.has(key)) continue;
			seen.add(key); rows.push(row);
		}
		const hasMore = parsed.totalPages !== null ? page + 1 < parsed.totalPages : parsed.total !== null ? (page + 1) * 100 < parsed.total : parsed.rows.length === 100;
		if (!hasMore) return rows;
		if (!parsed.rows.length) throw new Error("unrecognized");
	}
	// An incomplete list must not look like a confirmed absence of bans.
	throw new Error("unrecognized");
};

export const banStatus = createBanStatusCache(loadRows);
GD.S_AUTH_LOG_OUT.subscribe(() => banStatus.clear());
